export default "type coordinates = (int * int * int)\n// Type your solution below";